import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { InputText_s } from "styles/input-styles"
import { MultiRowCarouselState_s, SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const ADRDetailedAnnual = (props: {rowData: [], defaults: object, field: string, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyRecord = {
    amt: null
  }

  const [data, setData] = useState<object|null>(props.rowData[props.field])
  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }}), "date") : [{...emptyRecord, i: 0}]);

  function updateVal(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data || {})
    if(items[field[0]][field[1]] === val) return
    items[field[0]][field[1]] = val
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => ({...rest, year: i+1})))
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'detailedYr') _.set(newData, 'state', 'detailedYr')
    setData(newData)
    props.persist({
      inflation: newData['inflation'],
      items: newData.items,
      dateMode: 'relative',
      state: 'detailedYr'
    }, props.field, props.rowData)
  }

  function updateInflation(val): void {
    let newData = _.cloneDeep(data);
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    const inflation = {
      inflationMode: "namedItem",
      inflationNamedItemId: val
    }
    _.set(newData, 'inflation', inflation);
    setData(newData);
    props.persist({
      dateMode: "relative",
      state: "detailedYr",
      items: strippedItems,
      inflation,
    }, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let newData = _.cloneDeep(data);
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest));
    _.set(newData, 'items', strippedItems);
    if (newData.state !== 'detailedYr') _.set(newData, 'state', 'detailedYr');
    setData(newData)
    props.persist({
      inflation: newData['inflation'],
      items: strippedItems.map((item, i) => { return {...item, year: i + 1}}),
      dateMode: newData.dateMode,
      state: 'detailedYr'
    }, 'adrdetail', props.rowData);
  }

  useEffect(() => {
    if (props['rowData']['adrdetail']?.state !== 'detailedYr'){
      setItems([{...emptyRecord, i: 0}]);
      setData({inflation: props.defaults['adrInflation']});
    }
  }, [props['rowData']])

  let renderItems = _.sortBy(items, 'i');

  const attrs = (field) => field_attrs('room', `${props.field}.items`)(field)(props.rowData, props)
  const infl_attrs = (field) => field_attrs('room', 'adrdetail')(field, (e) => _(e.path).take(2).isEqual(['adrdetail', 'inflation']))(props.rowData, props)

  const inflationOptions = _.map(
    _.get(props, "namedItems.inflation"),
    item => {
      return {value: item.inflationid, label: item.code}
    }
  )

  return (
    <div>
      <SingleRowCarouselState_s style={{marginBottom: '10px'}}>
        <div>
          <label>Inflation</label>
          <DropdownInput className="automated" data={data} attrs={infl_attrs} field="inflation.inflationNamedItemId" options={inflationOptions} persist={updateInflation} />
        </div>
      </SingleRowCarouselState_s>
      { renderItems.map((row:object, i) => (
        <MultiRowCarouselState_s className="carousel-multi-row">
          <div>
            { i === 0 && <label>Year</label> }
            <InputText_s readOnly value={i+1} className="year-input" />
          </div>
          <div>
            { i === 0 && <label>Amt</label> }
            <NumberInput
              attrs={attrs}
              className="automated"
              data={items}
              field={[`${row['i']}`, 'amt']}
              min={0}
              persist={updateVal}
              readPrecision={4}
              writePrecision={4}
            />
          </div>
          <RowAddRemove emptyRecord={{amt: null, i}} setState={updateItems} row={i} items={items} />
        </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default ADRDetailedAnnual
